import { useToast } from '@chakra-ui/react';
import { QueryKey, useQuery } from '@tanstack/react-query';
import { PendingResponse } from 'api/ControllingApi';
import { AxiosInstance } from 'axios';
import { useAxios } from 'context/AxiosContextProvider';
import { manageErrorResponse } from 'helpers/manageErrorResponse';
import { useEffect } from 'react';

import config from '../config';

export async function getPendingValues(axios: AxiosInstance): Promise<PendingResponse> {
  const { data } = await axios.get(`${config.apiBaseUrl}/op/v1/controlling/pending`);
  return data;
}

export default function useControllingPendingQuery() {
  const axios = useAxios();
  const toast = useToast();

  const query = useQuery({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: getKey(),
    queryFn: () => getPendingValues(axios),
    retry: false,
  });

  useEffect(() => {
    if (query.isError) {
      manageErrorResponse(toast, JSON.stringify(query.error as any));
    }
  }, [query.error, query.isError, toast]);

  return query;
}

function getKey() {
  return ['ControllingPending'] as const satisfies QueryKey;
}
useControllingPendingQuery.getKey = getKey;
